"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
}); //================================================================ 

/** @module std */
//================================================================

var gamma_1 = require("./gamma");
/**
 * Beta function.
 *
 * @reference https://en.wikipedia.org/wiki/Beta_function
 */


function beta(x, y) {
  return gamma_1.tgamma(x) * gamma_1.tgamma(y) / gamma_1.tgamma(x + y);
}

exports.beta = beta;